import { Injectable } from '@angular/core';
import { Effect, Actions, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { Action, select, Store } from '@ngrx/store';
import * as fromRouter from '~core/store';
import { switchMap, map, catchError, filter, withLatestFrom } from 'rxjs/operators';

import {
  LoadPlpSeoContent,
  LoadPlpSeoContentFailure,
  LoadPlpSeoContentSuccess,
  PlpSeoActionTypes
} from './plp-seo.actions';
import { PlpSeoInitialState } from './plp-seo.state';
import { ErrorResponse, SeoContent } from '~shared/models';
import { UrlUtils } from '~app/modules/generic/utils/url.utils';
import { CatalogService } from '~app/modules/catalog/services/catalog.service';
import { getCategory } from '~app/modules/generic/store';

@Injectable({
  providedIn: 'root'
})
export class PlpSeoEffects {
  private activeRoute$ = this.store$.pipe(select(fromRouter.getRouterState));

  constructor(
    private actions$: Actions,
    private catalogService: CatalogService,
    private store$: Store<fromRouter.RouterState>
  ) {
  }

  @Effect()
  loadSeoContent$: Observable<Action> = this.actions$.pipe(
    ofType(PlpSeoActionTypes.LOAD_PLP_SEO_CONTENT),
    switchMap((action: LoadPlpSeoContent) => {
      if (action.payload.categoryId) {
        return this.catalogService
          .getSeoContent(action.payload.categoryId)
          .pipe(
            map(
              (plpSEOContent: SeoContent) => new LoadPlpSeoContentSuccess({ plpSEOContent })
            ),
            catchError((error: ErrorResponse) =>
              of(new LoadPlpSeoContentFailure({ error }))
            )
          );
      } else {
        return of(new LoadPlpSeoContentSuccess({ plpSEOContent: PlpSeoInitialState.plpSEOContent }));
      }
    })
  );

  @Effect()
  LoadSeoContentByCategory$: Observable<Action> = this.store$.pipe(select(getCategory))
    .pipe(
      withLatestFrom(this.activeRoute$),
      filter(([category, route]) => !!category && route && UrlUtils.isCategoryPage(route.url)),
      map(([category, _]) => ({ categoryId: category.id })),
      switchMap(payload => of(new LoadPlpSeoContent(payload)))
    );

  // TODO Implement new clearSeoContent action and use it to reset the state
  @Effect()
  ResetSeoContent: Observable<Action> = this.store$
    .pipe(select(getCategory))
    .pipe(
      filter(category => !category),
      map(category => ({ categoryId: null })),
      switchMap(payload => of(new LoadPlpSeoContent(payload)))
    );
}
